import { render, staticRenderFns } from "./Medallas_agregar.vue?vue&type=template&id=257e0cd2"
import script from "./Medallas_agregar.vue?vue&type=script&lang=js"
export * from "./Medallas_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports